import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { CreateClinicForm } from './UserInviteForm'

export default function CreateClinicPage() {
  const navigate = useNavigate()
  const { currentUser, logout } = useAuth()
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get('returnTo') || '/admin/users'

  const handleCreated = () => {
    navigate(returnTo)
  }

  const handleCancel = () => {
    navigate(returnTo)
  }

  return (
    <div className="min-h-screen bg-[#F4F6F8] flex">
      {/* Sidebar */}
      <aside className="w-64 bg-gradient-to-b from-[#2c3e50] to-[#34495e] text-white flex flex-col shadow-2xl fixed h-screen">
        {/* Logo */}
        <button onClick={() => navigate('/')} className="p-4 border-b border-white/10 flex justify-center hover:opacity-80 transition-opacity cursor-pointer">
          <img src="/lucvan-logo-web.png" alt="Logo" className="h-16 brightness-0 invert" />
        </button>

        {/* Navegación */}
        <nav className="flex-1 px-3 py-6 space-y-2">
          <button
            onClick={() => navigate(returnTo)}
            className="w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium text-gray-300 hover:bg-white/10 hover:text-white transition-all"
          >
            <span className="text-xl text-white">⬅️</span>
            <span>Atrás</span>
          </button>
        </nav>

        {/* Info de usuario */}
        <div className="p-4 border-t border-white/10">
          <div className="mb-3">
            <p className="text-sm font-semibold truncate">{currentUser?.email}</p>
            <p className="text-xs text-gray-400 capitalize">{currentUser?.role || 'admin'}</p>
          </div>
          <button
            onClick={() => { logout(); navigate('/login') }}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 rounded font-medium transition-all"
          >
            <span>Cerrar Sesión</span>
          </button>
        </div>
      </aside>

      {/* Contenido principal */}
      <div className="flex-1 overflow-auto ml-64">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">Crear nueva clínica</h1>
            <p className="text-sm text-gray-500 mt-1">Complete el formulario con la información de la clínica</p>
          </div>

          <div className="bg-white rounded shadow p-6">
            <CreateClinicForm 
              onCreated={handleCreated}
              onCancel={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
